export default __webpack_public_path__ + "a0105a17ab7bfeb8a7f1c59bef4bb4a8.png";